import API from "helpers/api";
import { BASE_API_PATH } from "helpers/constants";

const ENDPOINT = `${BASE_API_PATH}reports/generate`;

const ok = (response) => ({
	status: response?.status >= 200 && response?.status < 300,
	data: response?.data,
});

// POST /api/reports/generate - fires a one-shot "generate this report and
// email me a download link when it's ready" request. The API returns
// 202 Accepted immediately; the user gets the email once the worker
// finishes rendering and uploading.
export const generateReportNow = async (body) => {
	try {
		return ok(await API.post(ENDPOINT, body));
	} catch (err) {
		return ok(err?.response);
	}
};
